import { render, staticRenderFns } from "./EnvPerformance.vue?vue&type=template&id=de284eda&scoped=true"
import script from "./EnvPerformance.vue?vue&type=script&lang=js"
export * from "./EnvPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de284eda",
  null
  
)

export default component.exports